<div class="text-center pt-4">
  <img src="{{env.BASE_URL_IMAGE}}/62b8b17263017ed475b3bfe42ec6a2b2-1655270701620.png" class="text-center" />
</div>
